import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DividerModule} from 'primeng/divider';
import {ReactiveFormsModule, FormControl, FormGroup} from '@angular/forms';
import {InputNumberModule} from 'primeng/inputnumber';
import {CurrencyPipe, NgIf, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {CurrencyFormatPipe} from "../../../shared/pipes/CurrencyFormatPipe";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {MessageModule} from "primeng/message";

@Component({
    selector: 'app-credit-selection',
    standalone: true,
    imports: [
        DividerModule,
        ReactiveFormsModule,
        InputNumberModule,
        CurrencyFormatPipe,
        TranslatePipe,
        MessageModule,
        NgIf,
    ],
    providers: [
        CurrencyPipe,
        {provide: 'LOCALE_ID', useValue: 'de-DE'}  // hier wird Locale gesetzt
    ],
    templateUrl: './credit-selection.component.html',
    styleUrls: ['./credit-selection.component.scss']
})

export class CreditSelectionComponent implements OnInit {
    @Output() payCredit = new EventEmitter<number>();

    // numerische Werte
    selectedCreditAmount = 0;

    // formatierte Strings für die Anzeige
    formattedPrice = '';
    formattedVat = '';
    formattedTotal = '';
    errorMessage: string | undefined = undefined;
    form = new FormGroup({
        creditAmount: new FormControl<number>(0),
        customAmount: new FormControl<number>(0),
    });

    constructor(private currencyPipe: CurrencyPipe,
                private translateService: TranslateService) {
        registerLocaleData(localeDe);
    }

    ngOnInit() {
        this.form.controls.creditAmount.valueChanges.subscribe((value: number | null) => {
            //this.calcValues(value);
            this.form.controls.customAmount.patchValue(value);
        });

        this.form.controls.customAmount.valueChanges.subscribe((value: number | null) => {
            this.calcValues(value);
        });
    }

    calcValues(value: number | null) {
        this.selectedCreditAmount = Number(value) ?? 0;

        const price = this.selectedCreditAmount;
        const vat = this.selectedCreditAmount * 0.19;
        const total = price + vat;

        // formatierte Strings
        this.formattedPrice = this.formatCurrency(price);
        this.formattedVat = this.formatCurrency(vat);
        this.formattedTotal = this.formatCurrency(total);
    }

    nextStep() {
        if(this.selectedCreditAmount < 5) {
            this.errorMessage = this.translateService.instant('sipo.payment-component.credit-selection-component.min-amount');
        }

        this.payCredit.emit(this.selectedCreditAmount);
    }

    private formatCurrency(amount: number): string {
        return this.currencyPipe.transform(
            amount,
            'EUR',
            'symbol',
            '1.2-2',
            'de-DE'
        ) ?? '';
    }
}

